import React from "react";

import styled, { css } from "styled-components";

import { ButtonGroup } from "../ButtonGroup";
import { Choose } from "../Choose";

export interface ChooseV2Option {
  id: string | number;
  name: string;
  disabled?: boolean;
}

export interface ChooseV2Props {
  required?: boolean;
  multiple?: boolean;
  invalid?: boolean;
  options: ChooseV2Option[];
  selected: (string | number)[];
  onChange: (ids: (string | number)[]) => void;
}

const StyledChoose = styled(Choose)`
  ${(props) =>
    !props.active &&
    css`
      background-color: transparent !important;
    `}
`;

export const ChooseV2: React.FC<ChooseV2Props> = ({
  required = false,
  multiple = false,
  invalid = false,
  options,
  selected,
  onChange,
}) => {
  const handleSelect = (id: string | number) => {
    if (multiple) {
      const newSelected = selected.includes(id)
        ? selected.filter((s) => s !== id)
        : [...selected, id];
      if (required && newSelected.length === 0) {
        return;
      }
      onChange(newSelected);
    } else {
      if (required && selected.includes(id)) {
        return;
      }
      const newSelected = selected.includes(id) ? [] : [id];
      onChange(newSelected);
    }
  };

  return (
    <ButtonGroup invalid={invalid}>
      {options.map((option) => (
        <StyledChoose
          key={option.id}
          active={selected.includes(option.id)}
          disabled={option.disabled}
          onClick={() => handleSelect(option.id)}
        >
          {option.name}
        </StyledChoose>
      ))}
    </ButtonGroup>
  );
};
